
  import { defineComponent, PropType } from 'vue';

  import { TDashboardCountryFilter } from '@/modules/ves/types/countryDashboards';

  import {
    COUNTRY_DASHBOARDS_VES_ACTIONS_NAME,
    COUNTRY_DASHBOARDS_VES_GETTERS_NAME,
  } from '../../../store/countryDashboards/name';
  import { TDashboardsIndicatorCardsConfig } from '../dashboards-indicator-cards/types';
  import DashboardsIndicatorCardsWithModals from '../dashboards-indicator-cards-with-modals/DashboardsIndicatorCardsWithModals.vue';
  import { TModalsConfig } from '../dashboards-indicator-cards-with-modals/types';

  export default defineComponent({
    name: 'CountryDashboardsIndicatorCards',
    components: {
      DashboardsIndicatorCardsWithModals,
    },
    props: {
      filter: {
        type: Object as PropType<TDashboardCountryFilter>,
        required: true,
      },
    },
    data(): {
      cardsConfig: TDashboardsIndicatorCardsConfig;
      modalsConfig: TModalsConfig;
    } {
      return {
        cardsConfig: {
          action: COUNTRY_DASHBOARDS_VES_ACTIONS_NAME.getIndicatorCards,
          getter: COUNTRY_DASHBOARDS_VES_GETTERS_NAME.getIndicatorCards,
        },
        modalsConfig: {
          eventsCountByTypes: {
            action: COUNTRY_DASHBOARDS_VES_ACTIONS_NAME.getEventsCountByTypes,
            getter: COUNTRY_DASHBOARDS_VES_GETTERS_NAME.getEventsCountByTypes,
          },
          agreementsCountByTypes: {
            action: COUNTRY_DASHBOARDS_VES_ACTIONS_NAME.getAgreementsCountByTypes,
            getter: COUNTRY_DASHBOARDS_VES_GETTERS_NAME.getAgreementsCountByTypes,
          },
        },
      };
    },
  });
